import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatchDetailViewModel } from '../sportsbook/sportsbook.models';
import { MatchDetailDateMetaComponent } from './match-detail-date-meta.component';

@Component({
  selector: 'app-match-detail-hero',
  standalone: true,
  imports: [TranslateModule, MatchDetailDateMetaComponent],
  templateUrl: './match-detail-hero.component.html',
  styleUrl: './match-detail-hero.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchDetailHeroComponent {
  readonly detail = input.required<MatchDetailViewModel>();
}
